import Swiper, { Autoplay, Navigation, Pagination } from 'swiper'

const initDefinitionColumns = () => {
  const slides = [...document.querySelectorAll('.dc__slide')].map((slide) => ({
    slide: slide,
    title: slide.querySelector('.dc__slide-title'),
    color: getComputedStyle(slide).getPropertyValue('--dc-slide-title-color'),
  }))

  const handleScroll = (columns, links) => {
    if (!window.matchMedia('(min-width: 1024px)').matches) return
    ;[...columns].some((column, columnIndex, arr) => {
      const { top, bottom } = column.getBoundingClientRect()

      if (bottom > 180) {
        arr.forEach((column, dataIndex) => column.classList[dataIndex === columnIndex ? 'add' : 'remove']('swiper-slide-active'))
        links.forEach((link, linkIndex) => link.classList[linkIndex === columnIndex ? 'add' : 'remove']('swiper-pagination-bullet-active'))

        return true
      }
    })
  }

  const initLinks = () => {
    const columns = document.querySelectorAll('[data-column-content]')
    const links = document.querySelectorAll('[data-column-link]')

    window.addEventListener('scroll', () => handleScroll(columns, links))
  }

  new Swiper('.dc__swiper.swiper', {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 24,

    autoplay: {
      enabled: true,
      delay: 3000,
      pauseOnMouseEnter: true,
    },

    navigation: {
      prevEl: '.dc__navigation-button.prev',
      nextEl: '.dc__navigation-button.next',
    },

    pagination: {
      el: '.dc__navigation-pagination',
      renderBullet: function (index, className) {
        return `
        <a class="dc__navigation-pagination-item ${className}" style="--dc-navigation-color: ${slides[index].color}" href="#dc-${index + 1}" target="_self" data-column-link>
            <span class="dc__navigation-pagination-bullet"></span>
            <span class="dc__navigation-pagination-label">${slides[index].title.innerText}</span>
        </a>
        `
      },
    },

    breakpoints: {
      1024: {
        enabled: false,
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,

        autoplay: {
          enabled: false,
        },
      },
    },
  })

  initLinks()
}

export default initDefinitionColumns
